// extracted by mini-css-extract-plugin
export default {"navBox":"FooterNav_navBox__HCnZP","nav":"FooterNav_nav__r4CwT"};